import { IconUsers } from '@tabler/icons-react';
import { WelcomeExtensions } from '@ayocore/platform/client/components/Welcome/WelcomeExtensions';

/**
 * Регистрация навигационных карточек technoalliance на WelcomePage.
 */
export function registerTechnoallianceWelcomeExtensions(): void {
  // Карточка «Лиды» на главной — маршрут /crm/leads регистрирует сам CRM-модуль.
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'technoalliance-crm-leads',
    label: 'Лиды',
    icon: IconUsers,
    url: '/crm/leads',
    order: 15,
  }));
}
